import {
  Component,
  NgZone,
  OnInit,
  ViewChild,
  TemplateRef,
  ElementRef,
} from "@angular/core";
import { AdvtService } from "../../_services/advt.service";
import { AlertService } from "../../_services/alert.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Http } from "@angular/http";
import { Subscription } from "rxjs/Subscription";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { RatingDialogComponent } from "../../rating-dialog/rating-dialog.component";
import { environment } from "../../../environments/environment";
@Component({
  selector: "app-bid-accept",
  templateUrl: "./bid-accept.component.html",
  styleUrls: ["./bid-accept.component.css"],
})
export class BidAcceptComponent implements OnInit {
  @ViewChild("template") template: TemplateRef<any>;
  private sub: Subscription;
  private returnPaypalCapture: Subscription;
  public _id;
  item_id;
  payerToken_id;
  paypalPayer_id;
  amount: "";
  approveGetPaypalApi: "";
  getPayoutApi: "";
  sellerIdSan: "";
  payoutStatus;
  senderBatchId: "";
  orderCaptureId: "";
  payPayOutValue: "";
  buyer_id;
  public listSingleItem;
  public seller_id: any;
  public bidPost;
  placeholder: any;
  currentUser: any;
  NAP;
  purchaseImage;
  checkoutImage;
  chatImage;
  model = 3.5;
  itemData;
  unique = "";
  uniquee = "";
  tax_amount: number;
  tax: number = 3;
  payable_amount: number;
  modalRef: BsModalRef;
  amountCent: number;
  public payment_token;
  rating: number = 5;
  comment;
  RateData;
  loading: Boolean = false;
  mainLoader;
  status: Boolean = false;
  Ratestatus: Boolean = false;
  amt;
  bidButton: Boolean = false;
  emojiIcon;
  transaction_id: string;
  payoutItemId: string;
  userAccessToken: string;
  BuyerDetailsToken: string;
  buyerName: string;
  buyerAddress: string;
  buyerZipCode: string;
  country_name: string;
  userId: string;
  modalLoaderActive: boolean = false;
  constructor(
    private advtService: AdvtService,
    private alertService: AlertService,
    private http: Http,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private router: Router
  ) { }
  ngOnInit() {
    this.mainLoader = "../../assets/images/BigLoader.gif";
    this.getSellerIdByMerchantId(this.sellerIdSan, "");
    const userInfo = JSON.parse(localStorage.getItem("currentUser"));
    this.currentUser = userInfo ? userInfo.result : null;
    this.userId = userInfo.result.id;
    this.unique = this.uuidv4();
    this.uniquee = this.uuidv5();
    this.BuyerDetails();
    if (this.payoutStatus == 201) {
      this.getPaymentPayouts();
    }
    this.sub = this.route.params.subscribe((params) => {
      this.item_id = params["item_id"];
      this.buyer_id = params["buyerid"];
    });
    this.chatImage = "../../assets/images/chat-img.jpg";
    this.purchaseImage = "../../assets/images/price-img.jpg";
    this.checkoutImage = "../../assets/images/checkout-img.jpg";
    this.NAP = "../../assets/images/nap.jpg";
    this.getItemDetail();
    this.returnPaypalCapture = this.route.queryParams.subscribe((res) => {
      if (res.token != null && res.PayerID != null) {
        this.loading = true;
        // setTimeout(() => {
        this.payerToken_id = res.token;
        this.paypalPayer_id = res.PayerID;
        this.loading = false;
        if (this.payerToken_id != null && this.paypalPayer_id != null) {
          this.captureOrder();
          // this.loading = true;
        }
        // }, 1000);
      }
    });
  }
  /**
   *
   */
  //  @param token
  public getItemDetail() {
    this.loading = true;
    this.item_id = this.item_id;
    this.advtService.getItemDetail(this.item_id).subscribe((data) => {
      this.itemData = data;
      this.seller_id = data.seller_id;
      this.sellerIdSan = data.seller_id;
      this.getSellerIdByMerchantId(this.sellerIdSan, this.itemData);
      this.amt = data.bidAmount;
      this.loading = false;
    });
  }
  public getSellerIdByMerchantId(sellerIdSan, itemDataa) {
    this.advtService
      .getSellerIdMerchantIdDetail(sellerIdSan)
      .subscribe((data) => {
        this.loading = false;
      });
  }
  /**
   * Function to open modal
   * @param template
   */
  /**
   *
  //  * @param token token generated during the transaction
   */
  uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
  uuidv5() {
    return "xxxxxxxx-xxxx-5xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
  // this.router.navigate(["/dashboard"])
  // createSandBoxOrderHref = async () => {
  //   debugger;
  //   const response2 = await fetch(
  //     `${environment.sandBoxUrll}v2/checkout/orders`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Authorization:
  //           "Bearer " + localStorage.getItem("CreatePaypalTokenresp"),
  //         "Content-Type": "application/json",
  //         "PayPal-Request-Id": `${this.uniquee}`,
  //         // "PayPal-Request-Id": "7b92603e-77ed-4896-8e78-5dea2050476d",
  //       },
  //       body: `{"intent": "CAPTURE",
  //             "purchase_units": [
  //         {
  //           "amount": {
  //             "currency_code": "USD",
  //             "value": ${this.amountCent}
  //           }
  //         }
  //       ],
  //       "payment_source": {
  //         "paypal": {
  //           "experience_context": {
  //             "payment_method_preference": "IMMEDIATE_PAYMENT_REQUIRED",
  //             "payment_method_selected": "PAYPAL",
  //             "brand_name": "Bid Jones",
  //             "locale": "en-US",
  //             "landing_page": "LOGIN",
  //             "shipping_preference": "SET_PROVIDED_ADDRESS",
  //             "user_action": "PAY_NOW",
  //             "return_url": "${environment.bidjonesUrl}bid-accept/${this.buyer_id}/${this.item_id}",
  //             "cancel_url": "${environment.bidjonesUrl}bid-accept/${this.buyer_id}/${this.item_id}"
  //           }
  //         }
  //       }
  //     }`,
  //     }
  //   ).then(async (response) => {
  //     if (response.status == 200) {
  //       // this.loading = true;
  //       const responseData = await Promise.all([response.json()]);
  //       debugger;
  //       this.approveGetPaypalApi = responseData[0].links[1].href;
  //       return responseData;
  //     } else {
  //       this.loading = false;
  //       // this.alertService.error("Something went wrong");
  //     }
  //   });
  // };

  BuyerDetails() {
    this.BuyerDetailsToken = JSON.parse(localStorage.getItem("currentUser"));
    this.buyerName = this.BuyerDetailsToken["result"].first_name, "name";
    this.buyerAddress = this.BuyerDetailsToken["result"].address, "address";
    this.buyerZipCode = this.BuyerDetailsToken["result"].zip_code, "zip_code";
    this.country_name = this.BuyerDetailsToken["result"].country_name, "country_name";
  }

  createSandBoxOrderHref = async () => {
    try {
      this.loading = true;
      const response = await fetch(`${environment.sandBoxUrll}v2/checkout/orders`, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("CreatePaypalTokenresp"),
          "Content-Type": "application/json",
          "PayPal-Request-Id": `${this.uniquee}`,
          "Accept": "application/json",
        },
        body: JSON.stringify({
          intent: "CAPTURE",
          purchase_units: [
            {
              amount: {
                currency_code: "USD",
                value: this.amountCent.toFixed(2),
              },
            },
          ],
          application_context: {
            brand_name: "Bid Jones",
            landing_page: "LOGIN",
            user_action: "PAY_NOW",
            // return_url: `http://localhost:4200/item-purchase?amount=${this.amountCent.toFixed(2)}&buyId=${this.buyer_id}&itemId=${this.item_id}`,
            return_url: `${environment.bidjonesUrl}item-purchase?amount=${this.amountCent.toFixed(2)}&buyId=${this.buyer_id}&itemId=${this.item_id}`,
            cancel_url: `${environment.bidjonesUrl}bid-accept/${this.buyer_id}/${this.item_id}`,
          },
        }),
      });

      if (response.status === 201) {
        const responseData = await response.json();
        this.approveGetPaypalApi = responseData.links[1].href;
        return responseData;
      } else {
        this.loading = false;
        // Handle the error appropriately
      }
    } catch (error) {
      this.loading = false;
      // Handle the error appropriately
    }
  };



  public async openModal(template: TemplateRef<any>) {
    this.modalLoaderActive = true;
    // debugger;
    this.loading = true;
    this.tax_amount = (this.amt * this.tax) / 100;
    this.payable_amount = this.amt - 0 + (this.tax_amount - 0);
    this.amountCent = this.payable_amount;
    this.modalRef = this.modalService.show(template);
    this.loading = true;
    await this.createSandBoxOrderHref();
    this.loading = false;
  }

  /**
   * function to Disbale Modal
   * @param event
   */
  public _hidemodal(event: any) {
    this.modalRef.hide();
  }
  /*
   * PAYMENT method
   */
  async openCheckout() {
    // debugger;
    // this.modalRef.hide();
    this.loading = true;
    await this.payoutOrder();
    await this.getPaymentPayouts();
    await this.openPaypalLink();

    // setTimeout(() => {
    //   this.loading = true;
    //   window.location.href = this.approveGetPaypalApi; 
    //   // this.finalPaymentSuccessApi();
    // }, 3000);

    // var handler = (<any>window).StripeCheckout.configure({
    //   key: "pk_test_8qFDtezJbEFFBjestSU6TaFO00HPPmu2Tx",
    //   locale: "auto",
    //   token: (token: any) => {
    //     this.createOrder(token.id);
    //   },
    // });
    // handler.open({
    //   name: "Bidjones",
    //   image: "../../assets/images/logo.png",
    //   // description: 'abc',
    //   // amount: this.amountCent
    // });
  }
  openPaypalLink() {
    this.loading = false;
    window.location.href = this.approveGetPaypalApi;
  }
  captureOrder = async () => {
    //debugger;
    const response2 = await fetch(
      `${environment.sandBoxUrll}v2/checkout/orders/${this.payerToken_id}/capture`,
      {
        method: "POST",
        headers: {
          Authorization:
            "Bearer " + localStorage.getItem("CreatePaypalTokenresp"),
          "Content-Type": "application/json",
        },
        body: ``,
      }
    ).then(async (response) => {
      if (response.status == 201) {
        if (this.payerToken_id != null || this.payerToken_id != undefined) {
          const responseData = await Promise.all([response.json()]);
          this.senderBatchId =
            responseData[0].purchase_units[0].payments.captures[0].id;
          this.payPayOutValue =
            responseData[0].purchase_units[0].payments.captures[0].amount.value;
          this.orderCaptureId = responseData[0].id;
          this.loading = true;
          this.payoutOrder();
          return responseData;
        }
      } else if (response.status === 422) {
        this.alertService.warning("Your amount is low for Paypal payment");
        this.router.navigate(["/dashboard"]);
        // this.loading = false;
        // this.alertService.error("ORDER_ALREADY_CAPTURED");
        //this.router.navigate(["/dashboard"]);
      } else {
        this.alertService.warning("Something went wrong");
      }
    });
  };
  // payoutOrder = async () => {
  //   //debugger;
  //   this.loading = true;
  //   const response2 = await fetch(
  //     `${environment.sandBoxUrll}v1/payments/payouts`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Authorization:
  //           "Bearer " + localStorage.getItem("CreatePaypalTokenresp"),
  //         "Content-Type": "application/json",
  //       },
  //       body: `{
  //         "items": [
  //             {
  //                 "amount": {
  //                     "currency": "USD",
  //                     "value": ${this.payPayOutValue}
  //                 },
  //                 "note": "Thanks for your patronage!",
  //                 "receiver": "${this.paypalPayer_id}",
  //                 "recipient_type": "PAYPAL_ID",
  //                 "sender_item_id": "${this.payerToken_id}"
  //             }
  //         ],
  //         "sender_batch_header": {
  //             "email_message": "You have a payout!",
  //             "email_subject": "You have received a payout! Thanks for using our service!",
  //             "sender_batch_id": "${this.unique}"
  //         }
  //     }`,
  //     }
  //   ).then(async (response) => {
  //     if (response.status == 201) {
  //       // this.loading = true;
  //       const responseData = await Promise.all([response.json()]);
  //       this.payoutStatus = response.status;
  //       this.getPayoutApi = responseData[0].links[0].href;
  //       this.getPaymentPayouts();
  //       //this.alertService.success("Payment Successfully done.");
  //       //this.router.navigate(["/dashboard"]);
  //       // setTimeout(() => {
  //       //this.loading = true;
  //       // }, 500);
  //       //this.loading = false;
  //       return responseData;
  //     } else if (response.status == 422) {
  //       //this.sellerMakePayment();
  //       // this.alertService.success("Payment Successfully done.");
  //       this.loading = false;
  //       this.alertService.warning("Your account balance is low");
  //       //this.router.navigate(["/dashboard"]);
  //       //this.loading = false;
  //       //this.alertService.warning("Your account balance is low");
  //       // this.alertService.error("Your account balance is low");
  //     } else {
  //       //this.loading = false;
  //       this.alertService.warning("Your account balance is low");
  //     }
  //   });
  // };

  payoutOrder = async () => {
    try {
      this.loading = true;

      const response = await fetch(`${environment.sandBoxUrll}v1/payments/payouts`, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("CreatePaypalTokenresp"),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              amount: {
                currency: "USD",
                value: this.amountCent.toString(),
              },
              note: "Thanks for your patronage!",
              receiver: `Garth@Bidjones.com`,
              recipient_type: "EMAIL",
              sender_item_id: `${this.payerToken_id}`,
            },
          ],
          sender_batch_header: {
            email_message: "You have a payout!",
            email_subject: "You have received a payout! Thanks for using our service!",
            sender_batch_id: `${this.unique}`,
          },
        }),
      });
      if (response.status === 201) {
        const responseData = await response.json();
        this.payoutStatus = response.status;
        this.getPayoutApi = responseData.links[0].href;
        // await this.getPaymentPayouts();
        return responseData;
      } else if (response.status === 422) {
        this.loading = false;
        this.alertService.warning("Your account balance is low");
      } else {
        this.loading = false;
        this.alertService.warning("Error processing payout. Please try again later.");
      }
    } catch (error) {
      this.loading = false;
      this.alertService.error("An unexpected error occurred. Please try again later.");
    }
  };

  getPaymentPayouts = async () => {
    try {
      this.loading = true;
      const response = await fetch(`${this.getPayoutApi}`, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("CreatePaypalTokenresp"),
          "Content-Type": "application/json",
        },
      });


      if (response.status === 200) {
        const responseData = await response.json();
        this.transaction_id = responseData.items[0].transaction_id;
        this.payoutItemId = responseData.items[0].payout_item_id;
        ///////
        localStorage.setItem(`${this.buyer_id}${this.item_id}_tid`, this.transaction_id);
        localStorage.setItem(`${this.buyer_id}${this.item_id}_pid`, this.payoutItemId);
        ///////
        const currentUserToken = JSON.parse(localStorage.getItem("currentUser"));
        this.userAccessToken = currentUserToken.access_token;
        // this.finalPaymentSuccessApi();
        return responseData;
      } else {
        // this.alertService.error("Something went wrong");
      }
    } catch (error) {
    }
  };


  // finalPaymentSuccessApi() {
  //   let input = {
  //     amount: this.amountCent.toString(),
  //     buyer_id: `${this.buyer_id}`,
  //     item_id: `${this.item_id}`,
  //     order_id: this.transaction_id,
  //     status: 'succeeded',
  //     transfer_id: this.payoutItemId,
  //     type: 1,
  //   };
  //   fetch('https://bidjones.com/bidjones/api/v1/seller/makePayment', {
  //     method: 'POST',
  //     headers: {
  //       'Authorization': `Bearer ${this.userAccessToken}`,
  //       'Content-Type': 'application/json',
  //     },
  //     body: JSON.stringify(input),
  //   })
  //     .then(response => {
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! Status: ${response.status}`);
  //       }
  //       return response.json();
  //     })
  //     .then(data => {
  //       // Handle the success response here
  //     })
  //     .catch(error => {
  //       // Handle errors here
c  //     });
  // }
  // { "amount": "10.00", "buyer_id": "666", "item_id": "27", "order_id": "dcdc", "status": "succeeded" }
  // public sellerMakePayment() {
  //   //this.loading = true;
  //   //debugger;
  //   var input = {
  //     amount: this.amountCent.toString(),
  //     buyer_id: `${this.buyer_id}`,
  //     item_id: `${this.item_id}`,
  //     order_id: this.transaction_id,
  //     status: 'succeeded',
  //     transfer_id: "7YZMTXGT6XP74",
  //     type: 1,
  //   };
  //   this.advtService.makeSellerPayment(input).subscribe((data) => {
  //     if (data.status == 200) {
  //       this.router.navigate(["/dashboard"]);
  //       this.alertService.success("Payment Successfully done.");
  //       //this.loading = false;
  //     } else {
  //       this.alertService.success("Payment Successfully done.");
  //       this.router.navigate(["/dashboard"]);
  //       //this.loading = false;
  //     }
  //   });
  // }

  createOrder(token) {
    this.loading = true;
    const params = {
      buyer_id: this.buyer_id,
      amount: this.amountCent,
      item_id: this.item_id,
      payment_token: token,
    };
    this.advtService.getPaymentToken(token, params).subscribe((res) => {
      if (res.status === 200) {
        this.status = true;
        this.alertService.success("Payment Successfully done.");
        let ratingCheck = JSON.parse(localStorage.getItem("currentUser"));
        ratingCheck.result.rating_pending = 1;
        ratingCheck.result.rating_against_seller = this.seller_id;
        localStorage.setItem("currentUser", JSON.stringify(ratingCheck));
        // this.modalRef = this.modalService.show(RatingDialogComponent);
        this.router.navigate(["/dashboard"]);
        this.loading = false;
      } else {
        this.status = false;
      }
    });
  }
  public minBid(searchValue: String) {
    if (this.comment > searchValue) {
      this.bidButton = true;
    } else {
      this.bidButton = false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/authorized-data/bid-accept/bid-accept.component.ts